<div #container>
  @for (crumb of displayCrumbs(); track crumb.name) {
    <span>
      <a (click)="onClick(crumb)">
        {{ crumb.name | i18n }}
      </a>
    </span>
  }
</div>
